import { combineReducers } from 'redux';
import animationReducer from './animationReducer';
import drawerReducer from './drawerReducer';
import postsReducer from './postsReducer';

const hectorApp = combineReducers({
    animation: animationReducer,
    drawer: drawerReducer,
    posts: postsReducer
})

export default hectorApp;


// WEBPACK FOOTER //
// ./src/reducers/index.js